import React from 'react';
import {browserHistory} from 'react-router';

import styles from './GoBack.m.sass';
import LeftArrowIcon from '-!svg-react-loader?name=LeftArrowIcon!./assets/arrow-left.svg';

export default function GoBack() {
  return (
    <div className={styles.goBack}>
      <div className="container">
        <a href="#" className={styles.goBack_link} onClick={e => {e.preventDefault(); browserHistory.goBack()}}>
          <LeftArrowIcon className={styles.goBack_icon}/>
          <span className={styles.goBack_text}>Go Back</span>
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/goBack/GoBack.js